import {
  AppBar, Avatar,  Box, Divider, Grid, ListItemIcon, ListItemText, Menu,
  MenuItem, Stack, Toolbar, Typography
} from "@mui/material";
import React, { useState } from "react";

import Logout from "@mui/icons-material/Logout";
import { callAPI, getLocalValue, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import LabelDisplay from "../UpdateChange/LabelDisplay";
import WSCustomBreadcrumbs from "../BreadCrumbs/BreadCrumbsComp";
import { useSnackbar } from "../Snackbar/SnackBarContext";
import WSLoadingOverlay from "../WSLoadingOverlay";

interface NavbarProps {
  collapse: boolean;
  drawerWidth?: number;
  handleCollapse: () => void;
  anchorEl: null | HTMLElement;
  badgeContent?: number;
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
  backgroundColor?: string;
  iconColor?: string;
  height?: string;
}

const Navbar2: React.FC<NavbarProps> = ({
  collapse,
  drawerWidth = 240,
}) => {

  let UserId = localStorage.getItem("UserId");

  const { showMessage } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [profileAnchor, setProfileAnchor] = useState<null | HTMLElement>(null);
  const openProfileMenu = (event: React.MouseEvent<HTMLElement>) =>
    setProfileAnchor(event.currentTarget);
  const closeProfileMenu = () => setProfileAnchor(null);

  const handleLogout = async () => {
    try {
      setLoading(true);
      const response = await callAPI("/auth/logout", Method.POST, {
        userId: UserId,
      });

      localStorage.clear();
      showMessage(response?.message || "Logged out", "success");
      window.location.href = '/login';
      return;
    } catch (error: any) {
      console.error("Failed to logout", error);
      if (error.message === "GlobalHandledError") return;
      showMessage(
        error?.response?.data?.message || "Logout Failed",
        "error"
      );
    } finally {
      closeProfileMenu();
      setLoading(false);
    }
  };


  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${!collapse ? drawerWidth : 0}px)` },
          ml: { sm: `${!collapse ? drawerWidth : 0}px` },
          backgroundColor: '#ECF3F3',
          boxShadow: 0,
          mt: 1
        }}
      >
        <Toolbar>
          <Grid sx={{
            flexGrow: 1,
            marginLeft: collapse ? "140px" : "50px",
          }}>
            <LabelDisplay />
            <WSCustomBreadcrumbs />
          </Grid>

          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
              px: 1,
              py: 0.9,
              border: "1px solid #098963",
              borderRadius: 8,
              cursor: "pointer",
            }}
            onClick={openProfileMenu}
          >
            {" "}
            <Avatar sx={{ width: 25, height: 25 }} />
            <Typography
              sx={{
                background: 'linear-gradient(93.65deg, #4AD16E 1.28%, #08B1B6 105.72%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              {getLocalValue(LoacalVariables.Name)}
            </Typography>
          </Stack>

          <Menu
            anchorEl={profileAnchor}
            open={Boolean(profileAnchor)}
            onClose={closeProfileMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
              sx: {
                width: 220,
                borderRadius: 2,
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                py: 0.5
              }
            }}
          >
            {/* Profile Header */}
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid rgba(0, 0, 0, 0.05)' }}>
              <Typography variant="subtitle2" fontWeight="medium">
                {getLocalValue(LoacalVariables.Name)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {getLocalValue(LoacalVariables.UserType)} level user
              </Typography>
            </Box>

            {/* My Account */}
            {/* <MenuItem onClick={closeProfileMenu} sx={{ py: 1.5 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <AccountCircle fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="My Account" />
            </MenuItem> */}

            {/* Settings */}
            {/* <MenuItem onClick={closeProfileMenu} sx={{ py: 1.5 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Settings fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Settings" />
            </MenuItem> */}

            {/* Developer Contact */}
            {/* <MenuItem
              onClick={() => {
                closeProfileMenu();
                window.location.href = 'mailto:dev@example.com?subject=Support Request';
              }}
              sx={{ py: 1.5 }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Code fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Developer Contact" />
              <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                v2.4.1
              </Typography>
            </MenuItem> */}

            {/* Documentation */}
            {/* <MenuItem
              component="a"
              href="https://docs.example.com"
              target="_blank"
              rel="noopener"
              onClick={closeProfileMenu}
              sx={{ py: 1.5 }}
            >
              <ListItemIcon sx={{ minWidth: 36 }}>
                <HelpOutline fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Help & Docs" />
            </MenuItem> */}

            <Divider sx={{ my: 0.5 }} />

            {/* Logout */}
            <MenuItem
              onClick={handleLogout}
              sx={{ py: 1.5 }}
            >
              <ListItemIcon sx={{ minWidth: 36, color: 'error.main' }}>
                <Logout fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Logout" primaryTypographyProps={{ color: 'error' }} />
            </MenuItem>

            {/* Footer */}
            <Box sx={{
              px: 2,
              py: 1,
              fontSize: '0.7rem',
              color: 'text.secondary',
              textAlign: 'center',
              borderTop: '1px solid rgba(0, 0, 0, 0.05)'
            }}>
              © {new Date().getFullYear()} Kudumbashree Mission
            </Box>
          </Menu>
        </Toolbar>
      </AppBar >
      <WSLoadingOverlay loading={loading} />
    </>
  );
};

export default Navbar2;
